import {
  GET_CUSTOMER_PAYMENTS_REQUESTED,
  GET_CUSTOMER_PAYMENTS_SUCCEEDED,
  GET_CUSTOMER_PAYMENTS_FAILED,
  SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_REQUESTED,
  SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_SUCCEEDED,
  SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_FAILED
} from './constants'
import api from '../../utils/api'

export const getCustomerPaymentsRequested = () => ({
  type: GET_CUSTOMER_PAYMENTS_REQUESTED
})

export const getCustomerPaymentsSucceeded = (payload, customerId) => ({
  type: GET_CUSTOMER_PAYMENTS_SUCCEEDED,
  payload,
  customerId
})

export const getCustomerPaymentsFailed = () => ({
  type: GET_CUSTOMER_PAYMENTS_FAILED
})

export const loadCustomerPayments = (customerId) => dispatch => {
  dispatch(getCustomerPaymentsRequested())

  return api
    .fetchCustomerPayments(customerId)
    .then(response => dispatch(getCustomerPaymentsSucceeded(response.data.customerPayments)))
    .catch(() => dispatch(getCustomerPaymentsFailed()))
}

export const setCustomerPaymentAuthorizedSignatoryRequested = () => ({
  type: SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_REQUESTED
})

export const setCustomerPaymentAuthorizedSignatorySucceeded = (payload) => ({
  type: SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_SUCCEEDED,
  payload
})


export const setCustomerPaymentAuthorizedSignatoryFailed = () => ({
  type: SET_CUSTOMER_PAYMENT_AUTHORIZED_SIGNANTORY_FAILED
})

export const setCustomerPaymentAuthorizedSignatory = customerPayments => dispatch => {
  dispatch(setCustomerPaymentAuthorizedSignatoryRequested())

  return api
    .setCustomerPaymentAuthorizedSignatory(customerPayments)
    .then(response => dispatch(setCustomerPaymentAuthorizedSignatorySucceeded(response)))
    .catch(() => dispatch(setCustomerPaymentAuthorizedSignatoryFailed()))
}
